module.exports = __webpack_public_path__ + "img/team-22.61cf33cc.jpg";